import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SharedModule } from '../../../../core/modules/shared.module';
import { ToastComponent } from './toast.component';
import { CostOptionDropdownComponent } from './cost-option-dropdown/cost-option-dropdown.component';
import { TimeMaterialSectionComponent } from './time-material-section/time-material-section.component';
import { MatChipListComponent } from './mat-chip-list/mat-chip-list.component';
import { FlatRateSectionComponent } from './flat-rate-section/flat-rate-section.component';
import { ByTheFootSectionComponent } from './by-the-foot-section/by-the-foot-section.component';


@NgModule({

    imports: [
        SharedModule,
    ],

    declarations: [
        /** Header componet */
        HeaderComponent,
        ToastComponent,
        CostOptionDropdownComponent,
        TimeMaterialSectionComponent,
        MatChipListComponent,
        FlatRateSectionComponent,
        ByTheFootSectionComponent
    ],

    exports: [
        /** Header componet */
        HeaderComponent,
        TimeMaterialSectionComponent,
        FlatRateSectionComponent,
        ByTheFootSectionComponent,
        MatChipListComponent,
        CostOptionDropdownComponent,
        ToastComponent
    ],
    entryComponents: [
    ],
    providers: [
        ToastComponent
    ]
})
export class CommonComponentModule { }


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/common/common-component.module.ts